import {
  SET, SET_QUESTION_RESPONSE, UNSET_QUESTION_RESPONSE
} from './actionTypes';

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.surveyResponse;

    case SET_QUESTION_RESPONSE:{
      let questionResponses = state.questionResponses.filter(resp => parseInt(resp.question) !== parseInt(action.questionResponse.question));
      questionResponses.push(action.questionResponse);

      return {
        ...state,
        questionResponses: questionResponses.map(questionResponse => {
          if(questionResponse.question === action.questionResponse.question){
            questionResponse = action.questionResponse;
          }

          return questionResponse;
        })
      };
    }
      
    case UNSET_QUESTION_RESPONSE: {
      return {
        ...state,
        questionResponses: state.questionResponses.filter(resp => parseInt(resp.question) !== parseInt(action.question))
      };
    }

    default:
      return state;
  }
};